// © 2015-2021 WDNA - All Rights Reserved
import * as React from 'react';
import _ from 'lodash';

import { UserDO } from 'wdna-components/lib/types.new';

import store from '../../store/configure';

import {
  version as currentVersion,
  description as currentDesctiption
} from '../../../../package.json';

/**
 * Renders the footer element of the layout
 *
 * @returns footer element
 */
export default function Footer(): JSX.Element {
  const user: UserDO = _.get(store.getState(), ['auth', 'user']);

  return (
    <div className="page-footer">
      <div className="row" style={{ margin: '0px' }}>
        <span style={{ width: '50%', textAlign: 'left', padding: '0px 10px' }}>{currentDesctiption} {currentVersion} © 2017-{new Date().getFullYear()}</span>
        <span style={{ width: '50%', textAlign: 'right', padding: '0px 10px' }}>{user?.name || ''}</span>
      </div>
    </div>
  );
}
